const SUPPORTED = new Set(["it", "en"]);

/** Return a supported language from a browser locale, or null when unknown. */
export function languageFromBrowser(locale) {
  const value = String(locale || "").toLowerCase();
  const language = value.split("-")[0].split("_")[0];
  return SUPPORTED.has(language) ? language : null;
}

/** Read the browser preference without assuming a DOM (useful in tests/SSR). */
export function detectBrowserLanguage(navigatorLike = typeof navigator !== "undefined" ? navigator : null) {
  return languageFromBrowser(navigatorLike?.language || navigatorLike?.userLanguage);
}

/**
 * Best-effort country lookup for browsers whose language is not Italian or
 * English. The request is optional and never blocks the login form: network,
 * consent or provider errors simply return null.
 */
export async function detectLanguageByIp({ fetchImpl = globalThis.fetch, signal } = {}) {
  if (typeof fetchImpl !== "function") return null;
  try {
    const response = await fetchImpl("https://ipapi.co/json/", {
      headers: { Accept: "application/json" },
      signal,
    });
    if (!response?.ok) return null;
    const payload = await response.json();
    const country = String(payload?.country_code || "").toUpperCase();
    return country === "IT" ? "it" : country ? "en" : null;
  } catch {
    return null;
  }
}

export const DEFAULT_LANGUAGE = "en";
